import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'immutable';
import withActiveId from '../../components/hocs/withActiveId.react';
import ResourceListing from './ResourceListing.react';
import EditResourceForm from './EditResourceForm.react';

const ResourcesList = (
  { resources, currentlyEditing, activateIdFunc, deactivate },
) => (
  <div className='credential-listings-container'>
    <div className='credential-listings'>
      {resources.sort((a, b) => (a.id < b.id ? -1 : 1)).map((resource, index) => {
        if (resource.id === currentlyEditing || resource.id === -1) {
          return (
            <EditResourceForm
              key={resource.id}
              addTopBorder={index > 0}
              resource={resource}
              exitEditMode={deactivate}
            />
          );
        }
        return (
          <ResourceListing
            key={resource.id}
            addTopBorder={index > 0}
            resource={resource}
            enterEditMode={activateIdFunc(resource.id)}
          />
        );
      })}
    </div>
  </div>
);

ResourcesList.propTypes = {
  resources: PropTypes.instanceOf(List),
  currentlyEditing: PropTypes.number,
  activateIdFunc: PropTypes.func,
  deactivate: PropTypes.func,
};

export default withActiveId('currentlyEditing')(ResourcesList);
